import { render, staticRenderFns } from "./DetalharEvento.vue?vue&type=template&id=7eb0fc1f"
import script from "./DetalharEvento.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalharEvento.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports